export default __webpack_public_path__ + "static/media/DevinneSwash-qZd5.81e98134.ttf";